import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";

export function exportToExcel(data, columns, filename = "export") {
  const rows = data.map((row) =>
    columns.reduce((acc, col) => {
      acc[col.header] = col.accessor(row);
      return acc;
    }, {})
  );
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Data");
  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([buf], { type: "application/octet-stream" }), `${filename}.xlsx`);
}

export function exportToPDF(data, columns, filename = "export", title = "") {
  const doc = new jsPDF("l", "mm", "a4");
  if (title) {
    doc.setFontSize(14);
    doc.text(title, 14, 15);
  }
  const head = [columns.map((c) => c.header)];
  const body = data.map((row) => columns.map((c) => String(c.accessor(row) ?? "-")));
  doc.autoTable({ head, body, startY: title ? 22 : 10, styles: { fontSize: 8 }, headStyles: { fillColor: [184, 134, 11] } });
  doc.save(`${filename}.pdf`);
}
